// Epic 27.3: map the backend's structured template error codes (26.2/26.3/26.4)
// to i18n keys so both DE and EN render a localized message — and so web stays
// parity-identical with the Flutter client, which maps the same codes to .arb
// strings. We deliberately key off the machine-readable `code`, never the server
// message string.
//
// Backend codes (DataProviderAPI EmployeeTemplateController / WeekTemplateController):
//   OVERLAPPING_ACTIVE_TEMPLATE, CANNOT_DEFAULT_ARCHIVED, MUST_REASSIGN_DEFAULT,
//   INVALID_VALIDITY_RANGE, MISSING_NAME, MISSING_IDS.

const TEMPLATE_ERROR_KEYS = {
  OVERLAPPING_ACTIVE_TEMPLATE: "errorOverlappingActiveTemplate",
  CANNOT_DEFAULT_ARCHIVED: "errorArchivedCannotBeDefault",
  MUST_REASSIGN_DEFAULT: "errorReassignDefaultFirst",
  INVALID_VALIDITY_RANGE: "validToBeforeValidFrom",
  MISSING_NAME: "nameRequired",
  MISSING_IDS: "selectTemplatesToArchive",
};

// Pull the structured error code out of an axios-style error (the thunks reject
// with the raw error; its `response.data` is the `{ code, message }` body).
export const extractTemplateErrorCode = (error) => {
  const data = error?.response?.data ?? error?.payload ?? error;
  if (data && typeof data === "object" && typeof data.code === "string") {
    return data.code;
  }
  return null;
};

// Translate a backend error (or a bare code string) into a localized message.
// Falls back to the server-supplied message, then a generic key.
export const localizeTemplateError = (error, t) => {
  const code =
    typeof error === "string" ? error : extractTemplateErrorCode(error);
  const key = code ? TEMPLATE_ERROR_KEYS[code] : null;
  if (key) {
    return t(key);
  }
  const serverMessage =
    error?.response?.data?.message || error?.payload?.message || error?.message;
  return serverMessage || t("templateActionError");
};

export default localizeTemplateError;
